import React from "react";

export type TCRMGuidesHeaderCrumb = {
    label: string;
    href?: string;
};

export type TCRMGuidesHeaderProps = {
    title: string;
    breadcrumbs: Array<TCRMGuidesHeaderCrumb>;
    backHref?: string;
    backLabel?: string;
};

export const CRMGuidesHeader = (props: TCRMGuidesHeaderProps): JSX.Element => (
    <div className="crm-guides-header">
        <h1 className="crm-guides-header__title">{props.title}</h1>
        {props.breadcrumbs.length > 0 && (
            <nav className="crm-guides-header__breadcrumb" aria-label="Breadcrumb">
                {props.breadcrumbs.map((c, i) => (
                    <React.Fragment key={`${i}-${c.label}`}>
                        {i > 0 && <span className="crm-guides-header__breadcrumb-separator"> › </span>}
                        {c.href
                            ? <a className="crm-guides-header__breadcrumb-link" href={c.href}>{c.label}</a>
                            : <span className="crm-guides-header__breadcrumb-current">{c.label}</span>
                        }
                    </React.Fragment>
                ))}
            </nav>
        )}
        {props.backHref && (
            <div className="crm-guides-header__back-column">
                <a className="crm-guides-header__back" href={props.backHref}>
                    <span className="crm-guides-header__back-arrow">←</span>
                    <span className="crm-guides-header__back-label">{props.backLabel || "Back"}</span>
                </a>
            </div>
        )}
    </div>
);
